import { LinearProgress, Stack } from "@mui/material";
import { FC, Fragment, useCallback, useState } from "react";
import { GridApi } from "ag-grid-community";
import { CommitmentCsvExport } from "../../../../../common/components/data-grid/CommitmentCsvExport";
import { CommitmentsRecommendationsFilters } from "../../../../../utilization-and-coverage/components/content/recommendations/filters/CommitmentsRecommendationsFilters";
import { useAppSelector } from "@/store/hooks";
import { reservationsRecommendationsLoadingSelector } from "@/store/commitments/selectors/recommendations/reservations/reservationsRecommendationsLoadingSelector";
import { GlobalFilter } from "@/storybook/data-grid/toolbar/GlobalFilter";
import { AGGridColumnsToolPanel } from "@/components/pages/common/ag-grid/components/AGGridColumnsToolPanel";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";

interface ReservationsRecommendationsAGGridToolbarProps {
  gridApi: GridApi | null;
  overview?: boolean;
}

export const ReservationsRecommendationsAGGridToolbar: FC<
  ReservationsRecommendationsAGGridToolbarProps
> = ({ gridApi, overview }) => {
  const loading = useAppSelector(reservationsRecommendationsLoadingSelector);

  const [searchValue, setSearchValue] = useState("");

  const searchChangeHandler = useCallback(
    (keyword: string) => {
      gridApi?.setGridOption("quickFilterText", keyword);
      setSearchValue(keyword);
    },
    [gridApi],
  );

  return (
    <Fragment>
      <Stack p={1} pb={2} spacing={2}>
        <Stack
          justifyContent="space-between"
          alignItems="center"
          direction="row"
          gap={2}
          flexWrap="wrap"
        >
          <CommitmentsRecommendationsFilters type="reservation" />
          <span>
            <AgGridAllFiltersChip gridApi={gridApi} />
          </span>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flex={1}
            justifyContent="flex-end"
          >
            <GlobalFilter
              globalFilter={searchValue}
              setGlobalFilter={searchChangeHandler}
              size="xsmall"
              sx={{ width: 260 }}
            />

            <CommitmentCsvExport gridApi={gridApi} />

            <AGGridColumnsToolPanel gridApi={gridApi} />
          </Stack>
        </Stack>
      </Stack>

      {loading && <LinearProgress />}
    </Fragment>
  );
};
